import SimpleCharCountdown from '../components/SimpleCharCountdown'
import TriggerFileUpload from '../components/TriggerFileUpload'

export default class PublicationJobsEmailLists {
  constructor(params) {
    this.params = params;
  }

  index() {
    new TriggerFileUpload();
  }

  edit() {
    new SimpleCharCountdown({ editor: $('.js-char-editor') })
  }
}
